import { useLanguage } from "@/contexts/LanguageContext";
import { motion } from "framer-motion";

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="relative flex items-center gap-1 rounded-full bg-secondary px-3 py-1.5 text-xs font-bold transition-colors"
      aria-label="Toggle language"
    >
      <motion.div
        className="absolute inset-y-0.5 rounded-full gradient-primary"
        animate={{ left: language === "en" ? "2px" : "50%", width: "48%" }}
        transition={{ type: "spring", stiffness: 400, damping: 25 }}
        style={{ position: "absolute" }}
      />
      <span className={`relative z-10 px-1 transition-colors ${language === "en" ? "text-primary-foreground" : "text-secondary-foreground"}`}>
        EN
      </span>
      <span className={`relative z-10 px-1 transition-colors ${language === "bn" ? "text-primary-foreground" : "text-secondary-foreground"}`}>
        বাং
      </span>
    </button>
  );
};

export default LanguageToggle;
